var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{attrs:{"value":_vm.value},on:{"input":function (value) { return _vm.$emit('input', value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }